import { ICrisisStore } from './types';

const initStore: ICrisisStore = {
  current: null,
  crisisCalls: [],
  crisisCallTeamMembers: [],
};

export default initStore;
